import {useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";


export default function LoadListDetailsLoadFlagLookup(props) {
    //console.debug("RTS Break LoadListDetailsLoadFlagLookup");

    const [loadFlag, setLoadFlag] = useState(props.loadFlag);
    const [repoValues] = useState([{value:0, label:"Off"}, {value:1, label:"On"}]);


    function valChange(e, val){
        setLoadFlag(val.value);
        props.setLoadFlagFx(val.value);
        props.setFormDirtyFx(1);
    }

 
    return(
        <>
            <Autocomplete
                options={repoValues}
                renderInput={(params) => <TextField {...params} label="Load Flag" margin='normal' required size="small" />}
                value={repoValues.find(v => v.value===loadFlag)}
                onChange={valChange}
                getOptionLabel={(repoStatus) => repoStatus.label + ' (' + repoStatus.value + ')'}
                renderOption={(props, repoStatus) => (
                    <Box component="li" {...props} key={repoStatus.value}>
                        {repoStatus.label + ' (' + repoStatus.value + ')'}
                    </Box>
                )}
            />
        </>
    );
}
